/**
 * ToastContainer.tsx - Container that renders all toast notifications
 */

import React from 'react';
import { useToast } from '../../hooks/useToast';
import Toast from './Toast';
import styles from './Toast.module.css';

const ToastContainer: React.FC = () => {
  const { toasts, dismissToast } = useToast();

  return (
    <div className={styles.toastContainer}>
      {toasts.map(toast => (
        <Toast key={toast.id} toast={toast} onDismiss={dismissToast} />
      ))}
    </div>
  );
};

export default ToastContainer;
